module.exports = __webpack_public_path__ + "static/img_9838-cb4d1cb9e34aea22b1f3254c8b4f0f2b.webp";